export default "__VITE_ASSET__BbXnk1Qn__"